/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CdvxHealth } from './cdvxHealth';


export interface CdvxRuntime { 
    compute_node_count?: number;
    data_node_count?: number;
    health?: CdvxHealth;
    nv_log_status?: string;
    vm_count?: number;
}

